// src/services/socket.ts
import { io, Socket } from 'socket.io-client';

export const SOCKET_EVENTS = {
  JOIN_AUCTION: 'join-auction',
  LEAVE_AUCTION: 'leave-auction',
  JOIN_BROADCAST_AUCTION: 'join-auction-broadcast',
  LEAVE_BROADCAST_AUCTION: 'leave-auction-broadcast',
  AUCTION_BID_PLACE: 'auction:bid:place',
} as const;

export type ServerToClientEvents = {
  [SOCKET_EVENTS.AUCTION_BID_PLACE]: (payload: any) => void;
};
export type ClientToServerEvents = {
  [SOCKET_EVENTS.JOIN_AUCTION]: (payload: { auction_id: number }) => void;
  [SOCKET_EVENTS.LEAVE_AUCTION]: (payload: { auction_id: number }) => void;
  [SOCKET_EVENTS.JOIN_BROADCAST_AUCTION]: () => void;
  [SOCKET_EVENTS.LEAVE_BROADCAST_AUCTION]: () => void;
};

let socket: Socket<ServerToClientEvents, ClientToServerEvents> | null = null;

/**
 * Initialize (or return existing) socket.
 * Pass JWT token (optional) so server can authenticate socket connections.
 */
export const connectSocket = (token?: string) => {
  if (socket && socket.connected) return socket;

  socket = io(String(process.env.REACT_APP_API_BASE_URL ?? 'http://localhost:4000'), {
    auth: {
      token,
    },
    transports: ['websocket'],
    // optional reconnection policy
    reconnection: true,
    reconnectionAttempts: 5,
  });

  socket.on('connect', () => {
    // eslint-disable-next-line no-console
    console.debug('[socket] connected', socket?.id);
  });

  socket.on('disconnect', (reason) => {
    // eslint-disable-next-line no-console
    console.debug('[socket] disconnected', reason);
  });

  socket.on('connect_error', (err) => {
    // eslint-disable-next-line no-console
    console.warn('[socket] connect_error', err);
  });

  return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
